import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex-cen",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "proTableLinkPopContent" }
const _hoisted_4 = { style: {"height":"180px","width":"330px"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "popFoot" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"max-width":"200px"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/InfoIconSVG.svg",
  alt: "",
  class: "cursor-pt"
}, null, -1)
const _hoisted_13 = { class: "text-rt mt_10" }

import { ref, reactive, computed } from 'vue'
import { t } from '@/plugins/i18n'
import STable from '@/components/Table/index.vue'
import TableButton from '@/components/Table/TableButton.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { searchUrl, productDetail, batchSaveIfAbsent, searchProducts } from '@/apis/search'
import { useStore } from 'vuex'
import { formatMoney } from '@/plugins/utils'
import { tCurrency } from '../country'
import { COUNTRY } from '@/global'
import { isJA, isMultiStore } from '@/store'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  props: ['type', 'hasSet', 'list'],
  emits: ['commit'],
  setup(__props, { emit }) {

const props = __props
const searchType = ref(1)
const sourceCountry = [
  { label: t('中国'), value: 'CN' },
  { label: t('韩国'), value: 'KR' }
]
const store = useStore()
const multiStore = isMultiStore() ? [
  {
    align: 'center',
    prop: 'goodsCountry',
    slotName: 'goodsCountry',
    slotHeadName: 'goodsCountryTitle'
  }
] : []
const columns = [
  {
    label: t('图片'),
    prop: 'productSkuImg',
    align: 'center',
    slotName: 'image',
    width: 100
  },
  {
    label: t('商品名称'),
    prop: 'productTitle',
    align: 'center',
    'show-overflow-tooltip': true,
    width: 200
  },
  {
    label: t('商品类型'),
    prop: 'productType',
    align: 'center',
    slotName: 'type',
    width: 100
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'property',
    width: 140
  },
  ...multiStore,
  {
    label: t('单价'),
    prop: 'productSellPrice',
    align: 'center',
    slotName: 'price',
    width: 100
  },
  {
    label: t('操作'),
    prop: 'action',
    align: 'center',
    slotName: 'action'
  }
]
const dataSource = ref([])
const proTable = ref()



const url = ref('')
const searchLoading = ref(false)

const search = async () => {
  searchLoading.value = true
  if (searchType.value === 2) {
    const detail: any = await searchProducts({
      channelList: [1, 2, 5],
      keyword: url.value,
      langType: '1',
      pageNum: 1,
      pageSize: 50
    })
    if (detail.data?.records?.length === 1) {
      const product = detail.data.records[0]
      if (dataSource.value.some((i: any) => i.productCode === product?.productCode)) {
        ElMessage.error(t('商品已存在'))
        return
      }
      getDetail(product?.productCode)
    } else {
      ElMessage.error(t('商品不存在'))
    }
    return
  }
  request.goods.search.postSearch({
    detailUrl: url.value,
    channelList: isMultiStore() ? [1, 2, 5] : [1, 2],
    notChoice: 1
  })
    .then((res) => {
      console.log(res)
      if (dataSource.value.some((i: any) => i.productCode === res?.data?.productCode)) {
        ElMessage.error(t('商品已存在'))
        return
      }
      if ((res.data?.switchAllIncludePriceJp === 1 && !res.data.brandFlag) || (res.data?.fixedPriceFlag === 1 && !res.data?.brandFlag)) {
        return ElMessage.error(t('该商品不支持成本计算'))
      }
      if (res?.data?.country !== COUNTRY.CN && !isMultiStore()) {
        return ElMessage.error(t('商品不存在'))
      }
      getDetail(res?.data?.productCode)
    })
    .catch(() => {
      searchLoading.value = false
    }).finally(() => {
      searchLoading.value = false
    })
}

const formatSku = (res) => {
  const propMap = res.data.productPropGroupList
    .map((prop) => {
      return prop.props.map((props) => {
        return {
          ...props,
          type: prop.type
        }
      })
    })
    .flat()
  res.data.skuList.forEach((sku) => {
    sku.productProperties = sku.productProperties.split(';')
    sku.productPropertiesName = sku.productProperties.reduce(
      (t: string, i: any) => {
        const targetSku = propMap.filter((p: any) => p.propKey === i)[0]
        t += `${targetSku.type}:${targetSku.propValue}`
        return t
      },
      ''
    )
    if (!sku.productSkuImg) {
      sku.productSkuImg = res.data.productSkuImg || res.data.productMainImg
    }
  })
  return res
}

const getDetail = (productCode: string) => {
  productDetail({ productCode: productCode })
    .then((res) => {
      if (!res.success) {
        if (res.code === '410000003') {
          ElMessageBox.confirm(t('该商品是私域商品，您无法下单'), t('提示'), {
            confirmButtonText: t('确定'),
            cancelButtonText: t('取消'),
            type: 'warning'
          })
          return
        }
        return
      }
      const data = formatSku(res)
      dataSource.value.push(data.data)
      url.value = ''
    })
    .finally(() => {
      searchLoading.value = false
    })
}

const del = (row: unknown, rowIndex: number) => {
  console.log(row)
  dataSource.value.splice(rowIndex, 1)
}
const targetRef = ref()
const showProps = ($event, row) => {
  // if (row.skuList.length === 0) {
  //   productDetail({ productCode: row.productCode }).then(res => {
  //     const data = formatSku(res)
  //     if (data.data.skuList.length > 0) {
  //       row.skuList = data.data.skuList
  //       showPopPanel()
  //     } else {
  //       ElMessage.error(t('请重试'))
  //     }
  //   })
  // } else {
  //   showPopPanel()
  // }
  showPopPanel()
  function showPopPanel() {
    targetRef.value = $event.target
    dataSource.value.forEach(i => {
      i.propVisible = false
    })
    row.selCache = row.onSelProp || { productSku: '' }
    row.propVisible = true
  }
}

const onSkuItemClick = (row, sku, rowIndex) => {
  dataSource.value[rowIndex].selCache = sku
}

const saveSelCache = (row, rowIndex) => {
  const params = [{
    customerId: store.getters.user.customerId,
    customerName: store.getters.user.customerName,
    customerShopId: store.getters.curShop,
    customerShopName: store.getters.shopname,
    productSku: row.selCache.productSku,
    productType: 1
  }]
  batchSaveIfAbsent(params).then(res => {
    if (res.success) {
      dataSource.value[rowIndex].shopProductSku = res.data[0].shopProductSku
      dataSource.value[rowIndex].onSelProp = row.selCache
      row.propVisible = false
    }
  })
}

const commit = () => {
  const { size } = props.hasSet
  if (size + dataSource.value.length > 30) {
    ElMessage.error(t('超过组合sku数量，一个组合商品至多由30种不同单品sku组成'))
    return
  }
  console.log(props.list)
  console.log(dataSource.value)
  //   将外层的数据一起放在一块
  const newData = (props.list ?? []).concat(dataSource.value ?? [])
  //   是否都是一个国家下的商品
  const c1 = newData[0]?.goodsCountry || newData[0]?.country
  const isCommonGoodsCountry = newData.every((item: any) => {
    const c2 = item.goodsCountry || item.country
    return c1 === c2
  })
  if (!isCommonGoodsCountry) {
    ElMessage.error(t('不同国家的商品无法组合'))
    return
  }
  let hasSel = true
  if (dataSource.value.length) {
    // 加入到组合时，默认数量一个
    dataSource.value.forEach((v: any) => {
      if (!v.onSelProp) {
        hasSel = false
      } else {
        v.productSkuImg = v.onSelProp.productSkuImg
        v.productTitleJp = v.productTitleJp || v.productTitle
        v.productSellPrice = v.onSelProp.productSellPrice
        v.productPropertiesName = v.onSelProp.productPropertiesName
        v.productSku = v.onSelProp.productSku
        v.unitNums = 1
        v.goodsCountry = v.goodsCountry || v.country
      }
    })
    if (hasSel) {
      emit('commit', dataSource.value)
    } else {
      ElMessage.error(t('请选择规格后再追加'))
    }
  } else {
    ElMessage.error(t('至少选一个'))
  }
}

const selected = ref([])

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_block = _resolveComponent("block")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      "label-width": "160px",
      class: "proTableLinkForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('商品URL'),
          style: {"align-items":"center"}
        }, {
          label: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: searchType.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event)),
              placeholder: _unref(t)('请选择'),
              style: {"width":"160px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: _unref(t)('商品URL'),
                  value: 1
                }, null, 8, ["label"]),
                _createVNode(_component_el_option, {
                  label: _unref(t)('商品SKU'),
                  value: 2
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: url.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((url).value = $event)),
              style: {"width":"460px","margin-left":"20px"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_block, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: search,
                  loading: searchLoading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("搜索")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (url.value = ''))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("重置")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }),
    _createVNode(STable, {
      columns: columns,
      tableData: dataSource.value,
      height: "400px",
      class: "proTableLink",
      ref: (_value, _refs) => {
        _refs['proTable'] = _value
        proTable.value = _value
      },
      showPagination: false
    }, {
      image: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            style: {"width":"50px"},
            src: row.onSelProp ? row.onSelProp.productSkuImg :
            row.productSkuImg ||
            row.productMainImg
            ,
            alt: ""
          }, null, 8, _hoisted_2)
        ])
      ]),
      type: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('普通商品')), 1)
      ]),
      property: _withCtx(({ row, rowIndex }) => [
        _createVNode(_component_el_tooltip, {
          placement: "bottom",
          "hide-after": 30,
          effect: "light",
          visible: row.propVisible,
          "popper-class": "proTableLinkProp",
          trigger: "click",
          "append-to": proTable.value.$el,
          "virtual-ref": targetRef.value
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_scrollbar, { "max-height": 180 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.skuList, (sku) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sku.productSku,
                        class: _normalizeClass(sku.productSku !== row.selCache.productSku
                      ? 'proTableLinkSkuItem'
                      : 'proTableLinkSkuItem proTableLinkSkuItem_sel'
                      ),
                        onClick: ($event: any) => (onSkuItemClick(row, sku, rowIndex))
                      }, _toDisplayString(sku.productPropertiesName), 11, _hoisted_5))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("img", {
                src: row.selCache.productSkuImg ||
                row.productSkuImg ||
                row.productMainImg
                ,
                alt: ""
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (row.propVisible = false)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: ($event: any) => (saveSelCache(row, rowIndex))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 2
        }, 1032, ["visible", "append-to", "virtual-ref"]),
        (row.onSelProp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", null, _toDisplayString(row.onSelProp.productPropertiesName), 1),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (showProps($event, row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("变更")), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "text",
              onClick: ($event: any) => (showProps($event, row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("选择")), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
      ]),
      price: _withCtx(({ row }) => [
        _createElementVNode("div", null, [
          (row.onSelProp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(formatMoney)(row.onSelProp.productSellPrice) + _unref(tCurrency)('CNY', row.country)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, "-"))
        ])
      ]),
      action: _withCtx(({ row, rowIndex }) => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_popconfirm, {
            "popper-class": "pay-pop",
            title: _unref(t)('是否删除'),
            onConfirm: ($event: any) => (del(row, rowIndex))
          }, {
            reference: _withCtx(() => [
              _createVNode(TableButton, {
                title: _unref(t)('删除'),
                warning: true
              }, null, 8, ["title"])
            ]),
            _: 2
          }, 1032, ["title", "onConfirm"])
        ])
      ]),
      goodsCountryTitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('商品国家')) + " ", 1),
        _createVNode(_component_el_tooltip, {
          effect: "light",
          placement: "top",
          "popper-class": "tool-tip-no-border"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('不同国家的商品无法组合')), 1)
          ]),
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      goodsCountry: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(sourceCountry.find(item => item.value === row?.country)?.label), 1)
      ]),
      _: 1
    }, 8, ["tableData"]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: commit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("加入组合")) + " (" + _toDisplayString(dataSource.value.length) + ")", 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})